import { useState } from 'react';
import { FormControl, Stack, FormLabel } from '@chakra-ui/react';
import { Field } from 'formik';
import NumberField from 'components/forms/new/formikFormFields/NumberField';
import FieldToolTip from 'components/forms/new/FieldToolTip';
import { stackSpacing, formLabelStyling, stackStyling } from 'components/forms/new/formStyles';
import walkthroughIds from '../../walkthroughIds';
import NameField from 'components/forms/new/formikFormFields/NameField';

const PlanSimplePortingFeeField = ({ errors, touched, darkMode }) => {
    const [isHovered, setIsHovered] = useState(false);
    return (
        <FormControl
            sx={{ margin: '0 !important' }}
            isInvalid={!!errors.simplePortingFee && touched.simplePortingFee}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
        >
            <Stack direction="row" spacing={stackSpacing} sx={stackStyling()}>
                <FormLabel sx={formLabelStyling(darkMode)}>
                    Simple Porting Fee
                </FormLabel>
                <Field
                    as={NameField}
                    id="simplePortingFee"
                    name="simplePortingFee"
                    data-walkthroughid={walkthroughIds.plans.ufSimplePortingFeeInput}
                    error={errors.simplePortingFee}
                    type="number"
                    step="any"
                />
                {isHovered && (
                    <FieldToolTip
                        label="Simple porting fee (if any)."
                        ariaLabel="plan-simple-porting-fee-tip"
                        left="25px"
                        top="25px"
                    />
                )}
            </Stack>
        </FormControl>
    );
};

export default PlanSimplePortingFeeField;
